export default "__VITE_ASSET__kSv1AJwS__"